<template>
  <div class="min-height-for-section w-100 pt-livetv ">
    <div class="container-fluid mb-3">
      <div class="row searchinputstyle mx-2">
        <div
          class="searchicon d-flex justify-content-center align-items-center"
          style
        >
          <a href="#">
            <img src="../assets/top-menu/search-ico.png" />
          </a>
        </div>
        <!-- <div class="borderside d-flex justify-content-center align-items-start">
          <span>|</span>
        </div>-->
        <div
          class="inputbox pl-3 d-flex justify-content-center align-items-center"
        >
          <input
            v-model="searchinput"
            placeholder="Search"
            style="width:100%;"
            @input="searchRecord()"
          />
        </div>
        <div
          class="closebutton d-flex justify-content-center align-items-center"
          @click="clearQuery()"
        >
          <span class="closeicon">X</span>
          <span class="close_text">Clear</span>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row px-2 mt-4" v-if="vodArr.length > 0">
        <div class="col-12">
          <p class="type-title text-yellow">VOD</p>
        </div>
        <div
          class="col-6 col-md-3 my-3 px-1 px-md-3"
          style="z-index: 1;"
          v-for="item_vod in vodArr"
          :key="item_vod.id"
          @click="goTo(checkLink(item_vod))"
        >
          <VodCard
            :image="imgFiltering(item_vod)"
            :imageFeature="imgFiltering(item_vod, 'feature')"
            :title="formatString(item_vod.longTitle)"
            :description="item_vod.data.description"
            :link="checkLink(item_vod)"
            :category="item_vod.data.content_type[0].title.en_US"
          />
        </div>
      </div>

      <div class="row px-2 my-4" v-if="podcastArr.length > 0">
        <div class="col-12">
          <p class="type-title text-yellow">PODCAST</p>
        </div>
        <div
          class="col-6 col-md-3 my-3"
          v-for="item_pod in podcastArr"
          :key="item_pod.id"
          @click="goTo(checkLink(item_pod))"
        >
          <PodcastCard
            :image="imgFiltering(item_pod)"
            :title="formatString(item_pod.longTitle)"
            :description="item_pod.data.description"
            :link="checkLink(item_pod)"
          />
        </div>
      </div>
      <div class="row px-2 my-4" v-if="!loading && noResult">
        <div class="col-12">
          <p class="type-title text-yellow">
            Sorry, no result found. Try different keyword.
          </p>
        </div>
      </div>
      <div class="row px-2 my-4">
        <div
          v-if="loading"
          class="col-12"
          style="min-height: 30vh; display: flex; align-items: flex-start;justify-content: center;color: white;"
        >
          <p>loading</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable*/
import Vue from "vue";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import noimage from "../assets/noimage.png";
import axios from "axios";
import VodCard from "../components/cards/v2/vodCardStatic.vue";
import PodcastCard from "../components/cards/v2/podcastCard.vue";
export default {
  components: {
    BreadCrumbsHeader,
    VodCard,
    PodcastCard,
  },
  data: function() {
    return {
      searchinput: "",
      searchArr: [],
      vodArr: [],
      podcastArr: [],
      timeout: null,
      noimage: noimage,
      offset: 0,
      epsColStyles: {},
      window: {
        height: 0,
      },
      loading: false,
      noResult: false,
    };
  },
  methods: {
    goTo(link) {
      this.$router.push(link);
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    handleInput(e) {
      if (e.key === "Backspace" || e.key === "Delete") {
        this.clearQuery();
      }
    },
    clearQuery() {
      this.searchinput = "";
      this.vodArr = [];
      this.podcastArr = [];
      this.offset = 0;
    },
    searchRecord() {
      clearTimeout(this.timeout);
      var vm = this;
      vm.loading = true;
      vm.vodArr = [];
      vm.podcastArr = [];
      vm.offset = 0;
      vm.timeout = setTimeout(async function() {
        if (vm.searchinput) {
          const response = await axios.get(
            `https://rtb.glueapi.io/v1/content?offset=${
              vm.offset
            }&limit=100&query=*${vm.searchinput}*`
          );

          if (response.data.data.length != 0) {
            vm.getResult(response.data.data, response.data.count);
            vm.noResult = false;
          } else {
            vm.noResult = true;
          }

          vm.loading = false;
        } else {
          vm.clearQuery();
          vm.loading = false;
        }
      }, 2000);
    },
    getResult(value, totalItem) {
      this.offset = this.offset + 100;

      // new
      value.forEach((items, index) => {
        if (
          (items.idSchema == "205") |
          (items.idSchema == "207") |
          (items.idSchema == "209")
        ) {
          this.vodArr.push(items);
        } else if (items.idSchema == "203") {
          this.podcastArr.push(items);
        }
      });
    },
    imgFiltering(item, type = null) {
      let imgurl;
      const hasThumb =
        item.data && item.data.images && item.data.images.thumbnail;
      const hasTitle = item.data && item.data.images && item.data.images.title;
      const hasFeature =
        item.data && item.data.images && item.data.images.feature;

      // First try to get the specifically requested type if it exists
      if (type === "thumbnail" && hasThumb) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.thumbnail.path;
      } else if (type === "title" && hasTitle) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" + item.data.images.title.path;
      } else if (type === "feature" && hasFeature) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.feature.path;
      }
      // Fall back to original hierarchy if requested type doesn't exist or no type specified
      else {
        if (hasThumb) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.thumbnail.path;
        } else if (hasTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.title.path;
        } else if (hasFeature) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.feature.path;
        } else {
          imgurl =
            "https://cdn-rtb.glueapi.io/v1/content/" +
            item.id +
            "/image/300x0/images.title";
        }
      }

      return imgurl;
    },

    handleResize() {
      this.window.height = window.innerHeight;
      var minHeight = this.window.height - 57 + "px";
      Vue.set(this.epsColStyles, "min-height", minHeight);
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 90px 0 0;
  min-height: 80vh;
  font-family: "Poppins", sans-serif !important;
}
.breadCrumbsWrapper {
  padding: 30px;
}
.rtblogo {
  width: 120px;
}
.searchinputstyle {
  background: #313131;
  padding: 18px;
  border-radius: 4px;
}
.searchicon {
  width: 10%;
  padding: 0 10px;
}
.borderside {
  width: 2%;
}
.borderside span {
  color: #cccccc;
  font-size: 35px;
  font-weight: 500;
}
.inputbox {
  width: 80%;
}
.closebutton {
  width: 10%;
  cursor: pointer;
}
.closeicon {
  font-size: 16px;
  color: #fab900;
}
.close_text {
  font-size: 16px;
  color: #cccccc;
  margin-left: 10px;
}
input {
  background: #313131;
  border: none;
  color: #cccccc;
  height: 100%;
  outline: none;
}
.item {
  cursor: pointer;
}
.item .item_img {
  width: 100%;
  /* border: 1px solid #fab900; */
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  padding-top: 56.25%;
}
.item .item_img img {
  /* width: 100%;
  border-radius: 4px;
  overflow: hidden; */
  background: 100%;
  width: 120%;
  height: auto;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.type-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.19;
  text-align: left;
}
.text-yellow {
  color: #facb43;
}

@media only screen and (max-width: 480px) {
  .pt-livetv {
    min-height: auto;
    padding: 0;
  }
  .close_text {
    font-size: 13px;
  }
}
</style>
